import { safePanelTheme, type PanelTheme } from 'mormaii-web-presentation'

/**
 * Poe o tema na raiz da pagina - o `data-theme` que o `theme.css` le.
 *
 * Praia nao leva atributo: e o `:root` puro. Os outros dois viram `escuro` e `claro`.
 */
export function applyTheme(theme: PanelTheme): void {
    const root = document.documentElement
    if (theme === 'PRAIA') {
        delete root.dataset.theme
    } else {
        root.dataset.theme = theme.toLowerCase()
    }

    try {
        localStorage.setItem(CACHE_KEY, theme)
    } catch {
        // Sem armazenamento (aba privada, dado bloqueado): so o F5 pisca a foto.
    }
}

/**
 * O ultimo tema aplicado neste navegador, ANTES de a sessao responder.
 *
 * A escolha mora na conta e chega com a sessao, um instante depois da primeira pintura.
 * Sem este palpite, quem escolheu Escuro ou Claro veria a foto da praia a cada F5. Quem
 * saiu fica em Praia, porque sair aplica Praia - e entao o palpite tambem e Praia.
 */
export function applyCachedTheme(): void {
    let cached: string | null = null
    try {
        cached = localStorage.getItem(CACHE_KEY)
    } catch {
        // idem
    }
    applyTheme(safePanelTheme(cached))
}

const CACHE_KEY = 'mms.panelTheme'
